import * as api from '../api';
import { toDosCommandLineArgument } from "../dos-utils"
import { IpcRenderSend } from "./ipcRenderer"

export function IpcRenderSendClientIntegrated(on: boolean) {
  IpcRenderSend('teams-client-controller', {
    Command: on ? 'teamsclientintegrated' : 'quit',
  })
}

export async function IpcRenderSendAdminStart(extension: string, pw: string) {
  const args = `-u ${toDosCommandLineArgument(extension)} -p ${toDosCommandLineArgument(pw)}`
  console.log('Starting IPFXWebAdmin with', args)
  IpcRenderSend('app-launcher', { Command: 'IpfxApp', AppExeName: 'IPFXWebAdmin.exe', Arguments: args })
}

export function IpcRenderSendAdminStop() {
  api.closeFatClient()
}

export function IpcRenderShowMainWindow() {
  IpcRenderSend('set-main-window-state', 'show')
}
